import styles from "./myFooter.module.scss";
import Link from "next/link";
import DownBtn from "./DownBtn";

const MyFooter = () => {
  const footArr = [
    {
      title: "ABOUT US",
      list: [
        {
          title: "Contact",
          path: "/contact.html",
        },
        {
          title: "Faq",
          path: "http://blog.dingtone.me/en/202111-dingtone-faq/",
        },
        {
          title: "Support",
          path: "/support.html",
        },
        {
          title: "Our Users",
          path: "/ourusers.html",
        },
      ],
    },
    {
      title: "FOLLOW US",
      list: [
        {
          title: "Blog",
          path: "http://blog.dingtone.me/en/",
        },
        {
          title: "Twitter",
          path: "http://www.twitter.com/dingtone",
        },
      ],
    },
    {
      title: "Links",
      list: [
        {
          title: "TOP Network",
          path: "https://www.topnetwork.org/",
        },
        {
          title: "HiWallet",
          path: "https://www.hiwallet.org/en",
        },
        {
          title: "Download APK",
          path: "https://www.dingtone.me/Dingtone_Crypto.apk",
        },
      ],
    },
  ];

  return (
    <footer className={styles.footer}>
      <div className="main">
        <div className={styles.top}>
          <div className={styles.left}>
            <Link href="/">
              <a className={styles.logo}>
                <img src="/img/nav_logo.png" alt="logo" />
              </a>
            </Link>

            <p>
              Cheap international phone calls to United States, India,
              Bangladesh, Pakistan, Mexico, Philippines, Jamaica, Nepal,
              Nigeria, Saudi Arabia, Egypt, China, Brazil, United Kingdom,
              United Arab Emirates...
            </p>

            <DownBtn use="small"></DownBtn>
          </div>

          <div className={styles.right}>
            {footArr.map((item, index) => (
              <ul key={index}>
                <li>
                  <h3>{item.title}</h3>
                  <ul>
                    {item.list.map((itm, idx) => (
                      <li key={idx}>
                        <Link href={itm.path}>
                          <a>{itm.title}</a>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </li>
              </ul>
            ))}
          </div>
        </div>
        <div className={styles.bottom}>
          <div className={styles.cr}>
            © 2021{" "}
            <Link href="/">
              <a>Dingtone</a>
            </Link>
          </div>
          <div className="navList">
            <ul>
              <li>
                <Link href="/privacy_policy.html">
                  <a>Privacy Policy</a>
                </Link>
              </li>
              <li>
                <span>|</span>
              </li>
              <li>
                <Link href="/Terms_of_Service.html">
                  <a>Terms of Service</a>
                </Link>
              </li>
              <li>
                <span>|</span>
              </li>
              <li>
                <Link href="/sitemap.html">
                  <a>Site Map</a>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default MyFooter;
